import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./emptySpace.html";
import { images } from '~/modules/utilities/assetUtilities';
import pageTemplate from './emptySpace.html';
import textTemplate from './onlyTextEmptySpace.html';
import resourceTemplate from './resourceEmptySpace.html';
const UNLOCALIZED_LABEL = '** MISSING I18N **';
class EmptySpace extends LightningElement {
  constructor(...args) {
    super(...args);
    this.label = void 0;
    this.descriptionLabel = '';
    this.imageName = void 0;
    this.variant = void 0;
    this.imageAlt = '';
    this.buttonAction = void 0;
    this.buttonLabel = '';
    this.required = false;
    this.requiredText = UNLOCALIZED_LABEL;
    this.images = images;
  }
  render() {
    switch (this.variant) {
      case 'text':
        {
          return textTemplate;
        }
      case 'resource':
        {
          return resourceTemplate;
        }
      default:
      case 'page':
        {
          return pageTemplate;
        }
    }
  }
  get image() {
    return this.images[this.imageName];
  }
  get onlyTextEmptySpaceCSS() {
    const css = 'slds-grid empty-space-container slds-p-around_medium';
    return this.required ? `${css} empty-space-required` : `${css} slds-m-bottom_medium`;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(EmptySpace, {
  publicProps: {
    label: {
      config: 0
    },
    descriptionLabel: {
      config: 0
    },
    imageName: {
      config: 0
    },
    variant: {
      config: 0
    },
    imageAlt: {
      config: 0
    },
    buttonAction: {
      config: 0
    },
    buttonLabel: {
      config: 0
    },
    required: {
      config: 0
    },
    requiredText: {
      config: 0
    }
  },
  fields: ["images"]
});
const __lwc_component_class_internal = _registerComponent(EmptySpace, {
  tmpl: _tmpl,
  sel: "appx-empty-space",
  apiVersion: 62
});
export default __lwc_component_class_internal;